import request from "@/request";

// 模块名
const module = "";
// 控制器名
const controller = "CountyBasic";

// 路径
const path = `${module}/${controller}`;

/**
 * exec 执行命令 - 创建
 * @param {Object} params 参数
 */
export const execCreate = params => {
  return request.post(`/api/v1/${path}/create`, params);
};

/**
 * exec 执行命令 - 更新
 * @param {Object} params 参数
 */
export const execUpdate = params => {
  return request.post(`/api/v1/${path}/update`, params);
};

/**
 * 03 exec 执行命令 - 物理删除 单条
 * @param {Object} params 参数
 */
export const execDelete = params => {
  return request.get(`/api/v1/${path}/Delete`, { params });
};

/**
 * exec 执行命令 - 物理删除 批量
 * @param {Object} params 参数
 */
export const execDeleteBatch = params => {
  return request.post(`/api/v1/${path}/DeleteBatch`, params);
};

/**
 * exec 执行命令 - 软删除 单条
 * @param {Object} params 参数
 */
export const DeleteStudent = params => {
  return request.get(`/api/v1/${path}/DeleteStudent`, { params });
};

/**
 * exec 执行命令 - 软删除 批量
 * @param {Object} params 参数
 */
export const DeleteBatchStudent = params => {
  return request.post(`/api/v1/${path}/DeleteBatchStudent`, params);
};

/**
 * get 查询 - 得到实体对象
 * @param {Object} params 参数
 */
export const getItem = params => {
  return request.get(`api/v1/${path}/GetItem`, { params });
};

/**
 * get 查询 - 得到分页列表数据
 * @param {Object} params 查询参数
 */
export const getList = params => {
  return request.post(`api/v1/${path}/getlist`, params);
};

/**
 * get 查询 - 得到列表数据不分页
 * @param {Object} params 查询参数
 */
export const getAll = params => {
  return request.post(`api/v1/${path}/getAll`, params);
};

//---------------------- 上面为通用方法 和后台规约好了------------------------------
//---------------------- 巨完美的分割线 -------------------------------------------
//---------------------- 下面为特殊方法 如有需求请写在以下区域-----------------------

/**
 * 获取监测年度(接口地址是user)
 * @param {*} params
 */
export const getJcnd = params => {
  return request.post(`api/v1/system/user/GetJcnd`, params);
};
/**
* 省市区级联(接口地址是user)
* @param {*} params
*/
export const getAdress = params => {
  return request.post(`api/v1/system/user/GetArea`, params);
};
/**
* 获取题目接口
* @param {*} params
*/
export const getTopic = params => {
  return request.post(`api/v1/QuestionnaireManagement/ProblemHideDisplay/GetAllTree`, params);
};
